import React, { useRef } from 'react';
import { Box, Button, FormControlLabel, MenuItem, Modal, TextField, Typography } from '@mui/material';
import { Link, useNavigate, useParams } from 'react-router-dom';
import CancelIcon from '@mui/icons-material/Cancel';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import { useTheme } from '@mui/material/styles';
// import './ticket.css';
import CustomCheckbox from '../CustomCheckbox';
import IOSSwitch from './IosSwitch';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import CalendarIcon from '../CalendarIcon';
import { useState, useMemo } from 'react';
import {
  converterJsonToFormData,
  dateConverter,
  errorMessages,
  filterTrainers,
  imageValidation,
  sellStatus,
} from '../../utils/methods';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { FormInputText } from '../../form-components/FormInputText';
import { useForm } from 'react-hook-form';
import { FormInputDropdown } from '../../form-components/FormInputDropdown';
import FormInputCEditor from '../../form-components/FormInputCEditor';
import DeleteForeverIcon from '@mui/icons-material/DeleteOutline';
import { debounce } from '../../utils/methods';

import { deleteVODById, updateVOD, changeStatus, getVODById } from '../../api/ticket';
import { GridCloseIcon } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { FormInputDate } from '../../form-components/FormInputDate';
import { getPointTrainers } from '../../api/staff';
import { FormInputSearch } from '../../form-components/FormInputSearch';
import { useToast } from 'use-toast-mui';
import CustomRadioBox from '../CustomRadioBox';
import dayjs from 'dayjs';
import CloseIcon from '@mui/icons-material/Close';
import { sportOptions } from '../../constants/constants';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '440px',
  height: '331px',
  bgcolor: '#fff',
  borderRadius: '10px',
  border: 'none',
  padding: '14px 20px',
};
const options = [
  {
    label: '개인 레슨',
    value: 'PRIVATE_LESSON',
  },
  {
    label: '온라인 레슨',
    value: 'ONLINE_LESSON',
  },
  {
    label: '그룹 레슨',
    value: 'GROUP_LESSON',
  },
];

function DetailVOD() {
  const ref = useRef();
  const theme = useTheme();
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useToast();

  const user = useSelector(state => state.user.user);
  const [loader, setLoader] = useState(false);
  const [trainers, setTrainers] = useState();
  const [selected, setSelected] = useState();
  const [open, setOpen] = useState(false);
  const [ticketData, setTicketData] = useState({
    voucherList: [],
    trainerIdsList: [],
    curList: [{ title: '', outline: '', curImg: {} }],
    regPrice: '',
    disPrice: '',
    price: '',
    saleStatus: false,
  });

  const defaultValues = useMemo(() => {
    const defaults = {
      sports: ticketData?.sportType,
      kiosk: ticketData?.kioskProduct,
    };

    return defaults;
  }, [ticketData]);

  const { handleSubmit, control, setValue, getValues, reset, watch, setValues } = useForm({ defaultValues });
  const [usagePeriodType, setUsagePeriodType] = useState(true);

  const handleAddCard = () => {
    setTicketData({
      ...ticketData,
      curList: [...ticketData.curList, { title: '', outline: '', curImg: {} }],
    });
  };

  const handleSelect = id => {
    setSelected(id);
  };

  function handlechage(_, selected) {
    if (selected) {
      const { id, name } = selected;
      setTicketData({
        ...ticketData,
        trainerIdsList: [...ticketData.trainerIdsList, { id, name }],
      });
    }
  }

  const deleteVoucher = index => {
    setTicketData({
      ...ticketData,
      voucherList: ticketData.voucherList.filter((_, i) => i !== index),
    });
  };

  function removeTrainer(id) {
    setTicketData({
      ...ticketData,
      trainerIdsList: ticketData.trainerIdsList.filter(tr => tr.id !== id),
    });
  }

  const handleUploadTicketImages = async e => {
    try {
      const loadedImage = await imageValidation(e.target.files[0]);
      setTicketData({
        ...ticketData,
        voucherList: ticketData.voucherList.map((obj, index) => {
          if (index === selected) {
            return { ...obj, voucherImg: loadedImage };
          }
          return obj;
        }),
      });
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };

  async function uploadImages(e) {
    const files = e.target.files;
    const currentLength = [...ticketData.voucherList, ...files].length;
    const imageLimit = 7;

    if (currentLength > imageLimit) {
      alert(`You can only upload up to ${imageLimit} images.`);
      return;
    }

    const images = [];
    for (const file of files) {
      try {
        const loadedImage = await imageValidation(file);
        images.push({ voucherImg: loadedImage });
      } catch (error) {
        toast.error(errorMessages(error));
      }
    }

    setTicketData({
      ...ticketData,
      voucherList: [...ticketData.voucherList, ...images],
    });
  }

  function handleClose() {
    setOpen(false);
  }

  function setCard(e, index) {
    setTicketData({
      ...ticketData,
      curList: ticketData.curList.map((card, i) => {
        return i === index ? { ...card, [e.target.name]: e.target.value } : card;
      }),
    });
  }

  async function uploadCardImages(e, index) {
    try {
      const loadedImage = await imageValidation(e.target.files[0]);
      setTicketData({
        ...ticketData,
        curList: ticketData.curList.map((card, i) => {
          return i === index
            ? {
                ...card,
                curImg: loadedImage,
                fileName: loadedImage.name,
              }
            : card;
        }),
      });
    } catch (error) {
      toast.error(errorMessages(error));
    }
  }

  function deleteCurImage(index) {
    setTicketData({
      ...ticketData,
      curList: ticketData.curList.map((card, i) => {
        return i === index
          ? {
              ...card,
              curImg: {
                img: true,
              },
              fileName: '',
            }
          : card;
      }),
    });
  }

  function deleteVOD() {
    deleteVODById(id, user.token)
      .then(res => {
        toast.success('VOD Deleted');
        navigate('/vod');
      })
      .catch(err => {
        console.log(err);
        toast.error(errorMessages(err));
      });
  }

  const changeTicketStatus = async e => {
    const status = e.target.checked ? 'APPROVED' : 'EXPIRED';
    try {
      await changeStatus(status, id, user.token);
      toast.info('Ticket status Changed');
      setValue('saleStatus', status);
    } catch (error) {
      console.log('error', error);
      toast.error(errorMessages(error));
    }
  };

  const getTicket = async () => {
    try {
      const data = await getVODById(id, user.token);

      setTicketData({
        ...data,
        trainerIdsList: data.trainers.map(item => ({
          id: item.trainerId,
          name: item.trainerName,
        })),
        voucherList: data.images.map(item => ({
          voucherUrl: item,
        })),
        curList: data.curriculums.map(item => ({
          curriculumId: item.curriculumId,
          curImg: item.image,
          outline: item.summary,
          title: item.title,
          fileName: item.image,
        })),
      });

      reset(data);
    } catch (error) {
      console.log('error', error);
      toast.error(errorMessages(error));
    }
  };

  const submit = async values => {
    console.log('object');
    setLoader(true);
    const { branchName, voucherList, curList, trainerIdsList, ...filterTicketData } = ticketData;
    const { title, outline, curImg, fileName, ...filterValues } = values;

    const filteredData = {
      ...filterTicketData,
      ...filterValues,
      saleStartDate: dayjs(filterValues.saleStartDate).format('YYYY-MM-DD'),
      saleEndDate: dayjs(filterValues.saleEndDate).format('YYYY-MM-DD'),
      branchId: user.branch.branchId,
      hasSaleEndDate: values.hasSaleEndDate ?? false,
      classDetail: filterValues.classDetail,
    };
    const formData = new FormData();
    Object.keys(filteredData).forEach(key => {
      if (key === 'hasSaleEndDate') {
        formData.append(key, !filteredData[key]);
      } else if (key !== 'curriculums' && key !== 'trainers') {
        formData.append(key, filteredData[key]);
      }
    });

    trainerIdsList.forEach((trainer, index) => {
      console.log('🚀 ~ trainerIdsList.forEach ~ trainer:', trainer);
      formData.append(`trainers[${index}]`, trainer.id);
    });
    formData.delete('images');

    voucherList.forEach((voucher, index) => {
      if (voucher.voucherImg) {
        formData.append(`images[${index}].image`, voucher.voucherImg);
      } else {
        formData.append(`images[${index}].imageString`, voucher.voucherUrl);
      }
    });

    curList.forEach((cur, index) => {
      formData.append(`curriculums[${index}].title`, cur.title);
      formData.append(`curriculums[${index}].summary`, cur.outline);

      if (cur?.fileName?.includes('https://')) {
        formData.append(`curriculums[${index}].imageString`, cur.curImg);
      } else if (cur.fileName === '' || cur.curImg === null) {
        formData.append(`curriculums[${index}].imageString`, '');
      } else {
        formData.append(`curriculums[${index}].image`, cur.curImg);
      }
    });

    formData.append('sportType', values.sports);
    formData.append('kioskProduct', values.kiosk);

    formData.delete('descriptionVideo');
    formData.delete('descriptionVideoThumbnail');

    if (videoFile.file) {
      formData.append('descriptionVideo', videoFile.file);
    } else if (videoFile.url) {
      formData.append('descriptionVideoString', videoFile.url === null ? null : videoFile.url);
    }

    if (videoThumbnail.file) {
      formData.append('descriptionVideoThumbnail', videoThumbnail.file);
    } else if (videoThumbnail.url) {
      formData.append('descriptionVideoThumbnailString', videoThumbnail.url === null ? null : videoThumbnail.url);
    }

    formData.append('kioskProduct', values.kiosk === true ? values.kiosk : false);
    formData.append('usagePeriodType', usagePeriodType ? 'MONTH' : 'DAY');
    formData.append('usagePeriod', values.usagePeriod);
    formData.append('discountType', 'RATE');
    // formData.append('usagePeriod', values.usageCount);

    formData.delete('videos');

    videosOfCourses.forEach((videoOfCourse, index) => {
      formData.append(`videos[${index}].title`, videoOfCourse.title);
      formData.append(`videos[${index}].summary`, videoOfCourse.desc);
      if (videoOfCourse.video.file) {
        formData.append(`videos[${index}].video`, videoOfCourse.video.file);
      } else if (videoOfCourse.video.url) {
        formData.append(
          `videos[${index}].videoString`,
          videoOfCourse.video.url === null ? '' : videoOfCourse.video.url,
        );
      }
    });

    try {
      updateVOD(id, formData, user.token);
      toast.success(t('VOD updated successfully'));
      navigate('/vod');
    } catch (error) {
      toast.error(errorMessages(error));
      setLoader(false);
    }
  };

  useEffect(() => {
    setTicketData({
      ...ticketData,
      price: String(Math.round(ticketData.regPrice - ticketData.regPrice * (ticketData.disPrice / 100))),
    });

    setVideoFile({ file: null, url: ticketData?.descriptionVideo });
    setVideoThumbnail({ file: null, url: ticketData?.descriptionVideoThumbnail });
    setVideosOfCourses(
      ticketData?.videos?.map((video, index) => {
        return {
          title: video?.title,
          desc: video?.summary,
          video: { file: null, url: video?.video },
        };
      }) || [],
    );

    setValue('sports', ticketData?.sportType);
    setValue('kiosk', ticketData?.kioskProduct);

    setUsagePeriodType(ticketData?.usagePeriodType === 'MONTH' ? true : false);
  }, [ticketData.disPrice, ticketData.regPrice]);

  useEffect(() => {
    getTicket();
  }, []);
  useEffect(() => {}, [ticketData]);

  useEffect(() => {
    getPointTrainers(user.branch.branchId, user.token)
      .then(data => {
        setTrainers(data);
      })
      .catch(err => {
        console.log(err);
      });
  }, [user]);
  useEffect(() => {
    debounce(
      () => {
        setTicketData({
          ...ticketData,
          finalPrice: Math.round(+watch('regularPrice') - +watch('regularPrice') * (+watch('discountRate') / 100)) || 0,
        });
      },
      'set-finalPrice',
      1000,
    );
  }, [watch('regularPrice'), watch('discountRate')]);

  async function copyTicketData() {
    const { title, outline, ...filterValues } = getValues();
    localStorage.setItem(
      'ticket',
      JSON.stringify({
        ...filterValues,
        ...ticketData,
      }),
    );
    navigate('/vod/create');
  }

  const [videoFile, setVideoFile] = useState(null);
  const [videoThumbnail, setVideoThumbnail] = useState(null);
  const [videosOfCourses, setVideosOfCourses] = useState([{ title: '', desc: '', video: { file: null, url: null } }]);

  const deleteVideo = e => {
    e.preventDefault();
    setVideoFile({ file: null, url: null });

    const fileInput = document.getElementById('video');
    if (fileInput) {
      fileInput.value = '';
    }
  };

  const deleteVideoThumbnail = e => {
    e.preventDefault();
    setVideoThumbnail({ file: null, url: null });

    const fileInput = document.getElementById('video-thumbnail');
    if (fileInput) {
      fileInput.value = '';
    }
  };

  const handleUploadVideo = async event => {
    try {
      const file = event.target.files[0];
      if (file) {
        const videoURL = URL.createObjectURL(file);
        setVideoFile({ file: file, url: videoURL });
      }
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };

  const handleUploadVideoThumbnail = async event => {
    try {
      const file = event.target.files[0];
      if (file) {
        const imageURL = URL.createObjectURL(file);
        setVideoThumbnail({ file: file, url: imageURL });
      }
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };

  const handleChangePeriodType = type => {
    setUsagePeriodType(type);
  };

  const addCourseVideo = () => {
    setVideosOfCourses(prevValues => [...prevValues, { title: '', desc: '', video: { file: null, url: null } }]);
  };

  const deleteCourseVideos = idx => {
    setVideosOfCourses(prevValues => prevValues.filter((_, index) => index !== idx));
  };

  const handleVideoCoursesInfo = event => {
    const input = event.target.name.split('-');
    if (input[0] === 'title') {
      setVideosOfCourses(prevValues =>
        prevValues.map((value, index) => {
          if (index === Number(input[1])) {
            return { title: event.target.value, desc: value.desc, video: value.video };
          } else {
            return value;
          }
        }),
      );
    } else if (input[0] === 'desc') {
      setVideosOfCourses(prevValues =>
        prevValues.map((value, index) => {
          if (index === Number(input[1])) {
            return { title: value.title, desc: event.target.value, video: value.video };
          } else {
            return value;
          }
        }),
      );
    }
  };

  const handleUploadVideoCourse = async event => {
    const input = event.target.id.split('-');
    try {
      const file = event.target.files[0];

      if (file.size > 437 * 1024 * 1024) {
        toast.error('File size exceeds 437MB limit');
        return;
      }

      if (file) {
        const videoURL = URL.createObjectURL(file);

        const videoElement = document.createElement('video');
        videoElement.src = videoURL;

        videoElement.addEventListener('loadedmetadata', () => {
          const videoWidth = videoElement.videoWidth;
          const videoHeight = videoElement.videoHeight;

          if (videoWidth > 1280 || videoHeight > 720) {
            toast.error('Video resolution exceeds 1280x720');
            return;
          }

          setVideosOfCourses(prevValues =>
            prevValues.map((value, index) => {
              if (index === Number(input[1])) {
                return {
                  title: value.title,
                  desc: value.desc,
                  video: { file: file, url: videoURL },
                };
              } else {
                return value;
              }
            }),
          );
        });
      }
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };

  const deleteVideoCourseFile = (event, idx) => {
    event.preventDefault();

    setVideosOfCourses(prevValues =>
      prevValues.map((value, index) => {
        if (index === idx) {
          return { title: value.title, desc: value.desc, video: { file: null, url: null } };
        } else {
          return value;
        }
      }),
    );
  };
  return (
    <div
      style={{
        background: '#fff',
        borderRadius: '5px',
        padding: '20px',
        width: '1080px',
      }}>
      <p id="data"></p>
      <ul id="item"></ul>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', m: '20px' }}>
        <Box sx={{ display: 'flex' }}>
          <Link
            style={{
              textDecoration: 'none',
              color: '#3a3a3a',
              display: 'flex',
            }}
            to="/vod">
            <svg id="뒤로가기" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path id="Path_6534" data-name="Path 6534" d="M0,0H24V24H0Z" fill="none" />
              <circle
                id="Ellipse_96"
                data-name="Ellipse 96"
                cx="11"
                cy="11"
                r="11"
                transform="translate(1 1)"
                fill="#3a3a3a"
              />
              <path
                id="Path_6535"
                data-name="Path 6535"
                d="M6.393,8.579H14V9.865H6.393l3.352,3.448-.884.909L4,9.222l4.861-5,.884.909Z"
                transform="translate(3 2.778)"
                fill="#fff"
              />
            </svg>

            <Typography sx={{ fontSize: '18px', ml: '8px', fontWeight: '550' }}>수강권 수정</Typography>
          </Link>
        </Box>
        <Link
          style={{
            fontSize: '14px',
            fontWeight: 550,
            color: theme.palette.primary.main,
            textDecoration: 'none',
          }}
          to="/vod">
          {t('List')}
        </Link>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', mx: 3 }}>
        <Box sx={{ mt: '25px', mb: '25px' }}>
          <FormControlLabel
            sx={{ ml: '10px' }}
            onChange={changeTicketStatus}
            disabled={user.userRole === 'ROLE_MANAGER' && ticketData.saleStatus === 'APPROVAL_PENDING'}
            control={<IOSSwitch key={ticketData.saleStatus} defaultChecked={ticketData.saleStatus === 'APPROVED'} />}
          />
          <Typography sx={{ ml: '8px', mt: '10px', color: '#0F7F85' }}>
            판매&nbsp;{watch('saleStatus') === 'APPROVED' ? 'ON' : 'OFF'}
          </Typography>
        </Box>

        <Box sx={{ ml: '40px', width: '100%' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography sx={{ fontSize: '16px', fontWeight: 500 }}>
              {watch('ticketName')} {t(watch('classType'))} {watch('usageCount')}회 {watch('usagePeriod')}개월
            </Typography>
            <Button
              sx={{
                width: 'auto',
                ml: 1,
                p: '0',
              }}
              variant="outlined">
              {sellStatus(watch('saleStatus'), t)}
            </Button>
            <Button
              onClick={() => setOpen(true)}
              sx={{
                width: '120px',
                ml: 'auto',
                borderRadius: '10px',
                background: '#f1f4f6',
                color: '#707070',
                '&:hover': { backgroundColor: '#F1F4F6' },
              }}
              size="large">
              수강권 복사
              <ContentCopyOutlinedIcon sx={{ ml: '10px', width: '20px', height: '16px' }} />
            </Button>

            <Modal sx={{ cursor: 'pointer' }} open={open} onClose={handleClose}>
              <Box sx={{ ...style }}>
                <GridCloseIcon onClick={handleClose} sx={{ float: 'right' }} />
                <Box sx={{ mt: '80px' }}>
                  <Typography sx={{ fontSize: '18px', ml: '100px' }}>수강권을 복사하시겠습니까?</Typography>
                </Box>
                <Box sx={{ mt: '20px' }}>
                  <Typography sx={{ ml: '120px' }}>*복사시 즉시 게시되지 않으며</Typography>
                  <Typography sx={{ ml: '75px' }}>복사한 수강권은 목록에서 확인하실 수 있습니다.</Typography>
                </Box>
                <Box sx={{ display: 'flex', ml: '120px', mt: '70px' }}>
                  <Button
                    onClick={handleClose}
                    variant="contained"
                    sx={{
                      background: '#c5c5c5',
                      color: '#fff',
                      pl: '20px',
                      pr: '15px',
                      borderRadius: '10px',
                    }}>
                    {t('Cancel')}
                  </Button>
                  <Button
                    onClick={copyTicketData}
                    variant="contained"
                    sx={{
                      ml: '10px',
                      borderRadius: '10px',
                      px: '20px',
                    }}>
                    복사하기
                  </Button>
                </Box>
              </Box>
            </Modal>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <img style={{ width: '16px', height: '17px' }} src="/images/heart.svg" alt="love" />
            <Typography sx={{ ml: '5px', fontSize: '12px' }}>찜하기 수 {ticketData.likes ?? 0}</Typography>
          </Box>
        </Box>
      </Box>

      <hr style={{ border: '1px solid #e1e1e1' }} />
      <Box sx={{ m: 3 }}>
        <Typography sx={{ fontSize: '16px', fontWeight: 500 }}>{t('General Information')}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: '18px' }}>
          <Typography className="title" sx={{ width: '8%', fontWeight: 400 }}>
            {t('Seller Studio')}
          </Typography>
          <FormInputText
            control={control}
            sx={{ width: '480px', background: '#f1f4f6', color: '#A1A1A1' }}
            disabled
            staticValue={user.branch?.branchName}
            placeholder={t('VOD Type')}
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: '18px' }}>
          <Typography className="title" sx={{ width: '8%', fontWeight: 400 }}>
            {t('Sports')}
          </Typography>
          <FormInputDropdown
            disabledItem={<MenuItem disabled>{t('Choose a category')}</MenuItem>}
            name="sports"
            rules={{ required: false }}
            control={control}
            options={sportOptions}
            disabled
            value={ticketData?.sportType}
            sx={{ width: '480px', mr: 2 }}
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: '18px' }}>
          <Typography className="title" sx={{ width: '8%', fontWeight: 400 }}>
            {t('Pass Title')}{' '}
          </Typography>
          <FormInputText
            disabled
            control={control}
            sx={{ width: '480px' }}
            name="ticketName"
            rules={{ required: true }}
            placeholder={t('Type in the pass title')}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            columnGap: 1,
            mt: '18px',
          }}>
          <Typography className="title" sx={{ width: '8%', fontWeight: 400 }}>
            {t('Sales Price')}
          </Typography>
          <Typography sx={{ fontSize: '12px' }}>{t('List Price')}</Typography>
          <FormInputText
            control={control}
            rules={{ required: true }}
            sx={{ width: '100px', color: '#707070' }}
            placeholder={t('999,999')}
            name="regularPrice"
            type="tel"
          />
          <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>원</Typography>
          <div
            style={{
              width: '2px',
              height: '31px',
              background: '#ddd',
            }}
          />
          <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>{t('Discount Rate')}</Typography>
          <FormInputText
            control={control}
            rules={{ required: true }}
            sx={{ width: '57px', color: '#707070' }}
            placeholder="99"
            name="discountRate"
            InputProps={{ min: 5, max: 20 }}
            type="tel"
          />
          <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>%</Typography>
          <div
            style={{
              width: '2px',
              height: '31px',
              background: '#ddd',
            }}></div>
          <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>{t('Discount Rate')}</Typography>
          <FormInputText
            control={control}
            sx={{ width: '96px', color: '#111' }}
            staticValue={ticketData.finalPrice}
            placeholder={t('$0')}
            type="tel"
            InputProps={{
              readOnly: true,
            }}
          />
          <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>원</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: '18px' }}>
          <Typography className="title" sx={{ width: '8%', fontWeight: 400 }}>
            {t('Sales Period')}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
            <FormInputDate
              name="saleStartDate"
              control={control}
              rules={{ required: true }}
              placeholder={t('DD/MM/YYYY')}
              sx={{
                '.css-1x51dt5-MuiInputBase-input-MuiInput-input': {
                  fontSize: '16px',
                },
              }}
              renderInput={params => (
                <TextField
                  color="info"
                  size="small"
                  variant="outlined"
                  {...params}
                  sx={{
                    width: 150,
                    background: '#fff',
                    '.MuiInputBase-root': {
                      paddingRight: '0px',
                    },
                    '.MuiIconButton-root': {
                      marginRight: '0px',
                    },
                    input: {
                      paddingRight: '0px!important',
                    },
                    '& .MuiSvgIcon-root': {
                      fill: '#0F7F85 !important',
                    },
                  }}
                />
              )}
            />
            <p className="m-0">&nbsp;-&nbsp;</p>
            <FormInputDate
              name="saleEndDate"
              control={control}
              disabled
              // minDate={watch('saleStartDate')}
              // disabled={!watch('saleStartDate') || watch('hasSaleEndDate')}
              placeholder={t('DD/MM/YYYY')}
              sx={{
                '.css-1x51dt5-MuiInputBase-input-MuiInput-input': {
                  fontSize: '16px',
                },
              }}
              renderInput={params => (
                <TextField
                  color="info"
                  size="small"
                  variant="outlined"
                  {...params}
                  sx={{
                    width: 150,
                    background: '#fff',
                    '.MuiInputBase-root': {
                      paddingRight: '0px',
                    },
                    '.MuiIconButton-root': {
                      marginRight: '0px',
                    },
                    input: {
                      paddingRight: '0px!important',
                    },
                    '& .MuiSvgIcon-root': {
                      fill: '#0F7F85 !important',
                    },
                  }}
                />
              )}
            />
          </Box>
          <FormControlLabel
            control={
              <CustomCheckbox
                checked={!watch('hasSaleEndDate')}
                setValue={setValue}
                disabled
                name="hasSaleEndDate"
                sx={{ borderRadius: '100px' }}
              />
            }
            label={t('No closing date')}
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: '18px' }}>
          <Typography className="title" sx={{ width: '8%', fontWeight: 400 }}>
            {t('Validity Period')}
          </Typography>
          <FormInputText
            control={control}
            sx={{ width: '320px' }}
            rules={{ required: true }}
            name="usagePeriod"
            disabled
            placeholder={t('Type in the period')}
          />
          <FormControlLabel
            sx={{ ml: 1, fontWeight: 400 }}
            control={
              <CustomRadioBox checked={usagePeriodType === true} onChange={() => handleChangePeriodType(true)} />
            }
            label={t('Month(s)')}
          />
          <FormControlLabel
            sx={{ ml: 1, fontWeight: 400 }}
            control={
              <CustomRadioBox checked={usagePeriodType === false} onChange={() => handleChangePeriodType(false)} />
            }
            label={t('Day(s)')}
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: '18px' }}>
          <Typography className="title" sx={{ width: '8%', fontWeight: 400 }}>
            {t('Number of Lessons')}
          </Typography>
          <FormInputText
            control={control}
            sx={{ width: '320px' }}
            rules={{ required: true }}
            name="usagePeriod"
            disabled
            placeholder={t('Type in the number of lessons')}
            staticValue={ticketData?.usagePeriod}
          />
          <Typography sx={{ ml: 2, fontWeight: 400 }}>{t('Lesson(s)')}</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: '18px' }}>
          <Typography className="title" sx={{ width: '8%', fontWeight: 400 }}>
            {t('Instructor(s)')}
          </Typography>
          <Button
            sx={{
              background: '#707070',
              '&:hover': { backgroundColor: '#707070' },
              width: '150px',
              borderRadius: '10px',
            }}
            variant="contained">
            {t('Upload Instructor')}
          </Button>
          <FormInputSearch
            control={control}
            name=""
            sx={{
              width: '310px',
              marginLeft: '20px',
              '.MuiAutocomplete-endAdornment': {
                top: 'calc(50% - 10px)',
              },
            }}
            handleChange={handlechage}
            options={filterTrainers(trainers, ticketData.trainerIdsList)}
            placeholder={t('Type the client’s name')}
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: '18px' }}>
          <Typography sx={{ width: '8%' }}></Typography>
          <div
            style={{
              border: 'solid 1px #ddd',
              borderRadius: '5px',
              width: '480px',
              height: 'auto',
              minHeight: '95px',
            }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: 1,
                m: 1,
              }}>
              {ticketData.trainerIdsList?.map((tr, index) => (
                <Box key={index} sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                  <Typography
                    sx={{
                      background: '#fafbfc',
                      borderRadius: '20px',
                      fontSize: '13px',
                      padding: '8px 20px 7px',
                      color: theme.palette.primary.main,
                    }}>
                    {tr.name}
                  </Typography>
                  <CancelIcon
                    color="info"
                    onClick={() => removeTrainer(tr.id)}
                    sx={{
                      '&:hover': {
                        background: '#fff',
                        color: '#0F7F85',
                        cursor: 'pointer',
                      },
                    }}
                  />
                </Box>
              ))}
            </Box>
          </div>
        </Box>
      </Box>
      <Box sx={{ m: 3 }}>
        <Typography sx={{ mt: 2, mb: 2, fontSize: '16px', fontWeight: 500 }}>{t('Upload class videos')}</Typography>
        <Box>
          <Box>
            <Typography sx={{ width: '100%', fontWeight: 500 }}>{t('Class pass video')}</Typography>
            <Box
              sx={{
                mt: '11px',
                border: '1px solid #ddd',
                width: '1000px',
                padding: '30px 20px 15px',
                pt: '30px',
                pl: '20px',
                borderRadius: '5px',
              }}>
              {videosOfCourses?.map((videoCourse, index) => {
                return (
                  <Box
                    key={index + 1}
                    sx={{
                      display: 'flex',
                      width: '960px',
                      mb: '10px',
                      border: '1px dashed #ddd',
                      background: '#fafbfc',
                      borderRadius: '5px',
                      pt: '20px',
                      pr: '30px',
                      pb: '20px',
                    }}>
                    <Box sx={{ borderRight: '1px solid #e7e7e7', mr: '40px', pr: '40px' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography sx={{ fontWeight: 500, ml: 3, mr: 3 }}>{t('Title')}</Typography>
                        <FormInputText
                          control={control}
                          staticValue={videoCourse.title}
                          onChange={handleVideoCoursesInfo}
                          // rules={{ required: true }}
                          sx={{
                            ml: 'auto',
                            width: '370px',
                            height: '40px',
                            '.css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input': {
                              fontSize: '14px',
                              color: '#111',
                            },
                          }}
                          name={`title-${index}`}
                          inputProps={{ maxLength: 15 }}
                          placeholder={t('Curriculum')}
                        />
                        <Typography
                          sx={{
                            fontSize: '11px',
                            alignSelf: 'flex-end',
                            textAlign: 'right',
                            width: '35px',
                            pl: 1,
                          }}>
                          ({videoCourse.title.length}/15)
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
                        <Typography sx={{ fontWeight: 500, ml: 3, mr: 3 }}>{t('Overview')}</Typography>
                        <FormInputText
                          control={control}
                          staticValue={videoCourse.desc}
                          onChange={handleVideoCoursesInfo}
                          // rules={{ required: true }}
                          sx={{
                            ml: 'auto',
                            width: '370px',
                            height: '40px',
                            '.css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input': {
                              fontSize: '14px',
                              color: '#111',
                            },
                          }}
                          name={`desc-${index}`}
                          inputProps={{ maxLength: 40 }}
                          placeholder={t('Curriculum')}
                        />
                        <Typography
                          sx={{
                            fontSize: '11px',
                            alignSelf: 'flex-end',
                            textAlign: 'right',
                            width: '35px',
                            pl: 1,
                          }}>
                          ({videoCourse.desc.length}/40)
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <Box>
                        <Box>
                          <Box
                            sx={{
                              background: '#C1DBDE',
                              width: '144px',
                              height: '108px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              overflow: 'hidden',
                              borderRadius: '12px',
                            }}>
                            <label
                              htmlFor={`videoCourse-${index}`}
                              style={{
                                cursor: 'pointer',
                                height: '100%',
                                width: '100%',
                                position: 'relative',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}>
                              {videoCourse.video?.url || videoCourse.video?.file ? (
                                <>
                                  <video src={videoCourse.video?.url} style={{ height: '100%' }} />
                                  <Button
                                    style={{
                                      position: 'absolute',
                                      display: 'flex',
                                      minWidth: 'unset',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      backgroundColor: '#fff',
                                      bottom: '7px',
                                      right: '7px',
                                      padding: '4px',
                                    }}
                                    onClick={e => deleteVideoCourseFile(e, index)}>
                                    <DeleteForeverIcon sx={{ fontSize: '20px', color: '#000' }} />
                                  </Button>
                                </>
                              ) : (
                                <img src="/images/icons/video-icon.png" alt="Upload video" />
                              )}
                            </label>
                            <input
                              type="file"
                              id={`videoCourse-${index}`}
                              accept="video/*"
                              style={{ display: 'none' }}
                              onChange={handleUploadVideoCourse}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    {videosOfCourses.length > 1 && (
                      <CloseIcon
                        onClick={() => deleteCourseVideos(index)}
                        sx={{ fontSize: '32px', ml: 20, cursor: 'pointer' }}
                      />
                    )}
                  </Box>
                );
              })}
              <Box
                onClick={addCourseVideo}
                sx={{
                  display: 'flex',
                  columnGap: '10px',
                  '&:hover': {
                    color: theme.palette.primary.main,
                    cursor: 'pointer',
                  },
                }}>
                <ControlPointIcon color="#707070" />
                <Typography>{t('VOD 수업 추가')}</Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <hr style={{ border: '1px solid #e1e1e1' }} />
      <Box sx={{ m: 3 }}>
        <Typography sx={{ mt: 2, mb: 2, fontSize: '16px', fontWeight: 500 }}>{t('Details')}</Typography>

        <Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: '31px' }}>
            <Box>
              <Typography sx={{ width: '100%', fontWeight: 500 }}>{t('Video file')}</Typography>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',
                  border: '1px solid #ddd',
                  height: '245px',
                  width: '293px',
                  mt: 1,
                  mb: 1,
                  borderRadius: '5px',
                }}>
                <Box
                  sx={{
                    background: '#C1DBDE',
                    width: '240px',
                    height: '181px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    overflow: 'hidden',
                  }}>
                  <label
                    htmlFor="video"
                    style={{
                      cursor: 'pointer',
                      height: '100%',
                      width: '100%',
                      position: 'relative',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}>
                    {videoFile?.url || videoFile?.file ? (
                      <>
                        <video src={videoFile.url} style={{ height: '100%' }} />
                        <Button
                          style={{
                            position: 'absolute',
                            display: 'flex',
                            minWidth: 'unset',
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor: '#fff',
                            bottom: '7px',
                            right: '7px',
                            padding: '4px',
                          }}
                          onClick={e => deleteVideo(e)}>
                          <DeleteForeverIcon sx={{ fontSize: '20px', color: '#000' }} />
                        </Button>
                      </>
                    ) : (
                      <img src="/images/icons/video-icon.png" alt="Upload video" />
                    )}
                  </label>
                  <input
                    type="file"
                    id="video"
                    accept="video/*"
                    style={{ display: 'none' }}
                    onChange={handleUploadVideo}
                  />
                </Box>
              </Box>
            </Box>

            <Box>
              <Typography sx={{ width: '100%', fontWeight: 500 }}>{t('Video thumbnail')}</Typography>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',
                  border: '1px solid #ddd',
                  height: '245px',
                  width: '293px',
                  mt: 1,
                  mb: 1,
                  borderRadius: '5px',
                }}>
                <Box
                  sx={{
                    background: '#C1DBDE',
                    width: '240px',
                    height: '181px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    overflow: 'hidden',
                  }}>
                  <label
                    htmlFor="video-thumbnail"
                    style={{
                      cursor: 'pointer',
                      height: '100%',
                      width: '100%',
                      position: 'relative',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}>
                    {videoThumbnail?.url || videoThumbnail?.file ? (
                      <>
                        <img src={videoThumbnail.url} style={{ height: '100%' }} />
                        <Button
                          style={{
                            position: 'absolute',
                            display: 'flex',
                            minWidth: 'unset',
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor: '#fff',
                            bottom: '7px',
                            right: '7px',
                            padding: '4px',
                          }}
                          onClick={e => deleteVideoThumbnail(e)}>
                          <DeleteForeverIcon sx={{ fontSize: '20px', color: '#000' }} />
                        </Button>
                      </>
                    ) : (
                      <img src="/images/icons/image-icon.png" width={40} height={44} alt="Upload video thumbnail" />
                    )}
                  </label>
                  <input
                    type="file"
                    id="video-thumbnail"
                    accept="image/*"
                    style={{ display: 'none' }}
                    onChange={handleUploadVideoThumbnail}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box>
          <Typography sx={{ width: '11%', fontWeight: 500 }}>{t('Pass Design')}</Typography>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              border: '1px solid #ddd',
              width: '1000px',
              pt: '30px',
              mt: 1,
              borderRadius: '5px',
            }}>
            {ticketData.voucherList ? (
              <Box
                className="overscroll"
                sx={{
                  display: 'flex',
                  columnGap: '10px',
                  mx: '20px',
                  pb: '16px',
                  overflowX: 'auto',
                }}>
                {ticketData.voucherList.map((img, index) => {
                  return (
                    <label htmlFor="imageupload" key={index} style={{ position: 'relative' }}>
                      <img
                        onClick={() => handleSelect(index)}
                        key={index}
                        alt={'업로드 한 이미지 영역'}
                        src={img.voucherUrl ?? (window.URL || window.webkitURL).createObjectURL(img.voucherImg)}
                        width="240px"
                        height="180px"
                        style={{ objectFit: 'cover' }}
                      />
                      <input
                        type="file"
                        id="imageupload"
                        style={{ display: 'none' }}
                        onChange={e => handleUploadTicketImages(e)}
                      />
                      <Button
                        style={{
                          position: 'absolute',
                          display: 'flex',
                          minWidth: 'unset',
                          justifyContent: 'center',
                          alignItems: 'center',
                          backgroundColor: '#fff',
                          bottom: '7px',
                          right: '7px',
                          padding: '4px',
                        }}
                        onClick={() => deleteVoucher(index)}>
                        <DeleteForeverIcon sx={{ fontSize: '20px', color: '#000' }} />
                      </Button>
                    </label>
                  );
                })}
              </Box>
            ) : null}
            <Box sx={{ margin: '16px 20px' }}>
              {ticketData.voucherList?.length}/7
              <Button
                variant="contained"
                component="label"
                sx={{
                  mt: '12px',
                  background: '#707070',
                  '&:hover': { background: '#0F7F85' },
                  borderRadius: '10px',
                  float: 'right',
                }}>
                {t('Upload an image')}
                <input hidden accept="image/*" multiple type="file" onChange={uploadImages} />
              </Button>
              <Typography sx={{ fontSize: '11px', mt: '10px' }}>
                {t(
                  'Uploading images: You may upload maximum 7 images in the PNG or JPEG formats. The suggested maximum size is 8MB, 1200 * 900 px (ratio 4:3). Small and medium size thumbnails will be automatically generated with your uploaded images',
                )}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Typography
          sx={{
            mt: '31px',
            width: '11%',
            fontWeight: 500,
          }}>
          {t('Create Curriculum')}
        </Typography>
        <Box
          sx={{
            mt: '11px',
            border: '1px solid #ddd',
            width: '1000px',
            padding: '30px 20px 15px',
            pt: '30px',
            pl: '20px',
            borderRadius: '5px',
          }}>
          {ticketData.curList?.map((card, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                width: '960px',
                mb: '10px',
                border: '1px dashed #ddd',
                background: '#fafbfc',
                borderRadius: '5px',
              }}>
              <Box sx={{ display: 'flex', margin: '20px' }}>
                <Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Typography>제목</Typography>
                    <FormInputText
                      control={control}
                      staticValue={card.title}
                      onChange={e => setCard(e, index)}
                      sx={{
                        width: '370px',
                        height: '40px',
                        '.css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input': { fontSize: '14px', color: '#111' },
                      }}
                      name="title"
                      inputProps={{ maxLength: '15' }}
                      placeholder="필라테스 커리큘럼 필라."
                    />
                    <Typography sx={{ fontSize: '11px', alignSelf: 'end' }}>({card.title.length}/15)</Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      mt: '16px',
                      gap: 2,
                    }}>
                    <Typography>{t('Overview')}</Typography>
                    <FormInputText
                      onChange={e => setCard(e, index)}
                      control={control}
                      staticValue={card.outline}
                      name="outline"
                      sx={{ width: '370px' }}
                      inputProps={{ maxLength: '40' }}
                      placeholder="내용을 입력하여 주세요."
                      size="large"
                    />
                    <Typography sx={{ fontSize: '11px', alignSelf: 'end' }}>({card.outline.length}/40)</Typography>
                  </Box>
                </Box>
                <div
                  style={{
                    marginLeft: '20px',
                    width: '2px',
                    height: '107px',
                    background: '#ddd',
                  }}></div>
              </Box>
              <Box sx={{ ml: '20px', mt: '24px' }}>
                <Button
                  variant="contained"
                  component="label"
                  sx={{
                    background: '#707070',
                    '&:hover': { background: '#0F7F85' },
                    borderRadius: '10px',
                    color: '#fff',
                    width: '150px',
                  }}>
                  {t('Upload selected file')}
                  <input hidden accept="image/*" name="curImg" type="file" onChange={e => uploadCardImages(e, index)} />
                </Button>
                {card.fileName ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', mt: '16px' }}>
                    <Button
                      sx={{
                        borderRadius: '15px',
                        background: '#ebebeb',
                        color: '#707070',
                        '&:hover': { backgroundColor: '#ebebeb' },
                        padding: '8px 20px',
                        fontSize: '11px',
                        lineHeight: '11px',
                        mb: 2,
                      }}>
                      {/* {card.fileName} */}
                      <img
                        src={`${
                          card.fileName.includes('https://')
                            ? card.fileName
                            : (window.URL || window.webkitURL).createObjectURL(card.curImg)
                        }`}
                        width="40"
                        height="40"
                      />
                    </Button>
                    <CancelIcon
                      onClick={() => deleteCurImage(index)}
                      sx={{ ml: '6px', '&:hover': { color: '#0F7F85' } }}
                      color="info"
                    />
                  </Box>
                ) : null}
              </Box>
            </Box>
          ))}
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              margin: '12px 0 34px 20px',
              justifyContent: 'space-between',
            }}>
            {ticketData.curList?.length !== 5 ? (
              <Box
                onClick={() => handleAddCard()}
                sx={{
                  display: 'flex',
                  columnGap: '10px',
                  '&:hover': {
                    color: theme.palette.primary.main,
                    cursor: 'pointer',
                  },
                }}>
                <ControlPointIcon color="#707070" />
                <Typography>{t('Add Curriculum')}</Typography>
              </Box>
            ) : (
              <div></div>
            )}
            <Typography
              sx={{
                fontSize: '11px',
                color: '#707070',
                letterSpacing: '-0.28px',
              }}>
              *{' '}
              {t(
                'We recommend dimensions of 1200 * 900 px (ratio 4:3). Small and medium size thumbnails will be automatically generated with your uploaded images. Images must be either in the JPG or PNG formats',
              )}
            </Typography>
          </Box>
        </Box>

        <Box>
          <Typography
            sx={{
              mt: 3,
              fontWeight: 500,
            }}>
            {t('Class Description')}
          </Typography>
          <Box
            sx={{
              width: '1000px',
              border: '1px solid #ddd',
              borderRadius: '5px',
              mt: 1,
            }}>
            <FormInputCEditor setValue={setValue} control={control} data={ticketData.classDetail} name="classDetail" />
          </Box>
        </Box>
      </Box>
      <hr style={{ border: '1px solid #e1e1e1' }} />
      <Box
        sx={{
          m: 3,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Button
            onClick={deleteVOD}
            sx={{
              borderRadius: '12px',
              pl: '35px',
              pr: '35px',
              height: '36px',
              background: '#f7f7f7',
              color: 'red',
              border: 'none',
              '&:hover': {
                border: 'none',
                background: '#ef0c23',
                color: '#fff',
                cursor: 'default',
              },
            }}
            variant="outlined">
            수강권 삭제
          </Button>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          <CustomCheckbox
            color="primary"
            name="whenChecked"
            checked={watch('whenChecked')}
            onChange={e => setValue('whenChecked', e.target.checked)}
          />
          <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>게시</Typography>
          <Typography sx={{ ml: 1, fontSize: '12px', mr: '40px' }}>*체크시 등록하신 내용이 즉시 게시됩니다.</Typography>
          <Box>
            <Button
              onClick={() => navigate(-1)}
              sx={{
                borderRadius: '12px',
                pl: '35px',
                pr: '35px',
                mr: '6px',
                height: '36px',
                background: '#f7f7f7',
                color: '#9a9a9a',
                border: 'none',
                '&:hover': { background: '#ddd', cursor: 'default' },
              }}>
              {t('Cancel')}
            </Button>
            <Button
              onClick={handleSubmit(submit)}
              type="submit"
              disabled={loader}
              sx={{
                borderRadius: '12px',
                pl: '50px',
                pr: '50px',
                height: '36px',
                background: '#faf7fe',
                '&:hover': {
                  background: '#0F7F85',
                  color: '#fff',
                  cursor: 'default',
                },
              }}>
              {t('Save')}
            </Button>
          </Box>
        </Box>
      </Box>
    </div>
  );
}

export default DetailVOD;
